import { SET_CART_OFFERS, CHECK_ALL_CART_OFFERS,
  CHECK_CART_OFFER, DELETE_CART_OFFERS, SET_CART_OFFERS_DATA,
  SET_CART_COUPON, REMOVE_CART_COUPON
} from '../constants/cart';

const initialState = {
  list: [],
  coupon: null,
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CART_OFFERS:
      return {
        ...state,
        list: action.list.map((o, index) => {
            o.is_checked=true;
            o.price_number=parseFloat(o.price_number);
            o.discount_price_number=parseFloat(o.discount_price_number);
            o.original_discount_price_number=parseFloat(o.discount_price_number);
            o.discount=parseInt(o.discount);
            o.original_discount=parseInt(o.discount);
            o.author_id=o.user_created;
          return o;})
      };
    case DELETE_CART_OFFERS:
      return {
        ...state,
        list: state.list.filter(o => !action.ids.includes(o.id))
      };
    case CHECK_CART_OFFER:
      return {
        ...state,
        list: state.list.map(o => o.id === action.id ? {...o, is_checked: !o.is_checked} : o)
      };
    case CHECK_ALL_CART_OFFERS:
      return {
        ...state,
        list: state.list.map(o => ({...o, is_checked: action.is_checked}))
      };
    case SET_CART_COUPON:
      return { ...state, coupon: action.coupon }
    case REMOVE_CART_COUPON:
      return { ...state, coupon: null }
    default:
      return state;
  }
};

export default cartReducer;